import { v4 as uuidv4 } from 'uuid';
import React, { useState } from 'react';
import axios from 'axios';

const PaymentComponent = ({ onPaymentSuccess, amount, Currency, transId }) => {
  const [paymentStatus, setPaymentStatus] = useState(null);

  // Function to generate unique message ID
  function generateMessageId() {
    const timestamp = Date.now().toString(36);
    const randomPart = Math.random().toString(36).substring(2, 5);
    return `msg_${timestamp}${randomPart}`;
  }

  const handleCardPayment = () => {
    const isRefund = !!transId;

    // Fix the amount - assuming it might be in cents
    let processedAmount = parseFloat(amount);

    // If amount is suspiciously large, assume it's in cents and convert to dollars
    if (processedAmount > 1000) {
      processedAmount = processedAmount / 100;
      console.log('Converted from cents to dollars:', processedAmount);
    }

    // Round to 2 decimal places to fix floating point precision
    processedAmount = Math.round(processedAmount * 100) / 100;

    const payload = {
      messageId: generateMessageId(),
      posId: 'POS_12338',
      tranType: isRefund ? 'REFUND' : 'SALE',
      requestAmount: processedAmount,
      currency: Currency?.currency?.code || 'USD',
    };

    if (isRefund && transId) {
      payload.tranId = transId;
    }

    console.log('Original amount:', amount);
    console.log('Processed amount:', processedAmount);
    console.log('Final payload:', payload);

    initiatePayment(payload);
  };

  // Function to initiate payment request
  const initiatePayment = async (paymentData) => {
    try {
      console.log('=== MAKING REQUEST ===');
      console.log('URL: http://192.168.110.143:2433/v1/payment');
      console.log('Data:', paymentData);

      const response = await axios.post('/v1/payment', paymentData, {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 15000,
      });

      console.log('=== SUCCESS RESPONSE ===');
      console.log('Response:', response.data);

      if (response.data.tranStatus === 'APPROVED') {
        setPaymentStatus('Transaction Approved!');
        if (onPaymentSuccess) {
          onPaymentSuccess(response.data);
        }
      } else {
        setPaymentStatus('Transaction Declined. Try again with another card, please!');
        if (onPaymentSuccess) {
          onPaymentSuccess(response.data);
        }
      }
    } catch (err) {
      console.log('=== ERROR RESPONSE ===');

      // Safe error logging
      if (err && err.response) {
        console.log('Status:', err.response.status);
        console.log('Status Text:', err.response.statusText);
        console.log('Error Data:', err.response.data);
      } else if (err && err.message) {
        console.log('Error Message:', err.message);
      } else {
        console.log('Unknown error occurred');
      }

      // Safe error object logging
      try {
        console.log('Full Error Object:', JSON.stringify(err, null, 2));
      } catch (stringifyError) {
        console.log('Could not stringify error object');
      }

      setPaymentStatus('Transaction Error!');
      if (onPaymentSuccess) {
        onPaymentSuccess({
          error: (err && err.response && err.response.data) || (err && err.message) || 'Unknown error',
        });
      }
    }
  };

  return (
    <div className="row">
      <button className="AddBtn" onClick={handleCardPayment}>
        {transId ? `Refund ${Currency?.currency?.code} ${amount}` : `Pay ${Currency?.currency?.code} ${amount?.toFixed(2)} with Card`}
      </button>

      <div className="mt-2">{paymentStatus && <p>{paymentStatus}</p>}</div>
    </div>
  );
};

export default PaymentComponent;
